<template>
	<div class="iframe" :style="{height: height + 'px'}">
		<iframe
				:src="`http://ccc.cdboost.cn/${url}`"
				width="100%"
				height="100%"
				ref="iframeDom"
		></iframe>
	</div>
</template>

<script>
	export default {
		name: "introduce",
		data(){
			return {
				url: '',
				height: ''
			}
		},
		methods: {

		},
		created() {
			this.height = window.innerHeight
			this.url = this.$route.query.url;
		}
	}
</script>

<style scoped>

</style>